import styled from "styled-components";

export const BannerContainer = styled.div<{ statusType: string }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: ${({ statusType }) => {
    switch (statusType) {
      case "major":
        return "var(--color-danger)";
      case "partial":
        return "#ff8c00"; // Orange
      case "planned":
        return "var(--color-primary)";
      case "success":
        return "var(--color-success)";
      default:
        return "var(--color-text-60)";
    }
  }};
  color: white;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 20px;
  justify-content: center;
`;

export const StatusIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  opacity: 0.9;
`;

export const StatusMessage = styled.div`
  min-width: 0;
`;

export const StatusText = styled.div`
  font-size: 14px;
  font-weight: var(--fontWeightMedium);
  line-height: 1.4;
  margin-bottom: 2px;
`;

export const StatusType = styled.div`
  font-size: 12px;
  opacity: 0.8;
  text-transform: capitalize;
`;

export const DismissButton = styled.button`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:focus {
    outline: 2px solid rgba(255, 255, 255, 0.5);
    outline-offset: 2px;
  }
`;
